import NOTIFICATION_TYPES from 'constants/notificationType';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';
import { userService } from 'services/user.service';
import { openNotification } from 'utlis/notification';
import Routes from 'routes/routes';
import { setUser } from 'redux/actions/users.actions';
import { setOrganization } from 'redux/actions/organization.actions';
import { setOrganizationMembership } from 'redux/actions/organizationMembership.actions';
import { setFlowsCount } from 'redux/actions/flows.actions';
import { setJustLoggedIn } from 'redux/actions/misc.actions';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Buffer } from 'buffer';

const PostSignupMessage = ({ token }) => {
  const { t, ready } = useTranslation(['auth']);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  if (!ready) return null;

  useEffect(() => {
    if (!token) {
      console.warn('No token found, skipping useEffect');
      return;
    }

    localStorage.setItem('POR', Buffer.from(token).toString('base64'));

    const fetchData = async () => {
      try {
        const userProfile = await userService.getUserProfile();

        dispatch(setUser(userProfile.user));
        dispatch(setOrganization(userProfile.organization));
        dispatch(setOrganizationMembership(userProfile.organizationMembership));
        dispatch(setFlowsCount(userProfile.flowsCount));
        dispatch(setJustLoggedIn(true));

        navigate(Routes.app.dashboard);
      } catch (e) {
        localStorage.clear();
        openNotification(e.error, NOTIFICATION_TYPES.ERROR);
      }
    };

    const delay = setTimeout(() => {
      fetchData();
    }, 4000);

    return () => clearTimeout(delay);
  }, [token]);

  return (
    <Card className="bg-secondary shadow border-0 text-center">
      <CardBody>
        <p style={{ fontSize: '1.02rem' }}>
          {t('auth:postSignupMessageSubHeading')}
        </p>

        <p style={{ fontSize: '1.02rem' }}>
          {t('auth:postSignupMessageText')}{' '}
          <span className="spinner-border spinner-border-sm" />
        </p>

        {/* <p style={{ fontSize: '1.02rem' }}>
          {t('auth:postSignUpMessageFooter')}
        </p> */}
      </CardBody>
    </Card>
  );
};

export default PostSignupMessage;
